import { Component, Input, OnInit } from '@angular/core';
import { LogService } from '../../services/log.service';

@Component({
  selector: 'tank-grid-alarm-tooltip',
  templateUrl: './tank-grid-alarm-tooltip.component.html',
  styleUrls: ['./tank-grid-alarm-tooltip.component.css']
})
/** widget-alarm-details component*/
export class TankGridAlarmTooltipComponent implements OnInit {
  @Input() alarmList: any[];
  constructor(private logger: LogService) { }

  //listAlarms = [];

  ngOnInit(): void {
    this.logger.trackEvent('TankGrid', 'Column', 'TankGridAlarmRollover');
  };
}

